import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { VrrTable } from '../../../../shared_components';
import {
  filterDataOnKpisClaim,
  prepareHeaders,
  prepareBodies
} from './services';
import useSettings from '../../../../../libs/settings/useSettings';
import { getOverviewDMPreferences } from '../../../../../redux/settings/settingAction';
import { SORT_BY } from '../../../../shared_components/vrr_sort_by/constants';
import { TMetricData, TMetricTable } from './types';
import MetricTableStyles from './MetricTable.module.scss';

const MetricTable: React.FC<TMetricTable> = ({
  id,
  data,
  metricName,
  limitColumnKeys,
  limitRow
}: TMetricTable) => {
  const { overview } = useSettings();
  const mainKpi: string | undefined = useSelector(
    getOverviewDMPreferences
  )?.main_kpi;
  const mainKpiSort: string | undefined = useSelector(
    getOverviewDMPreferences
  )?.main_kpi_sort;

  const [tableData, setTableData] = useState<TMetricData>([]);

  useEffect(() => {
    const newTableData: TMetricData = filterDataOnKpisClaim(
      data,
      limitColumnKeys,
      metricName
    );
    setTableData(newTableData);
  }, [data]);

  const onSort = (sortId: string, sortType: string) => {
    if (sortId === mainKpi) {
      overview('detailed_metrics', {
        main_kpi_sort: sortType
      });
    }
  };

  return (
    <div id={id} className="metric-table-wrapper">
      <VrrTable
        cyId="overview-details-table"
        body={prepareBodies(tableData, limitColumnKeys)}
        header={prepareHeaders(limitColumnKeys)}
        defaultSort={{ id: mainKpi ?? '', type: mainKpiSort ?? SORT_BY.asc }}
        withSort
        onSortAction={onSort}
        limitRow={limitRow}
        tableProps={{
          className: 'metric-table',
          cssModule: MetricTableStyles
        }}
      />
    </div>
  );
};

export default MetricTable;
